export default "__VITE_ASSET__bdb492bd__"